<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <vx-card>
        <div>
          <vs-table
            v-if="ValidationRulesListData"
            @selected="handleSelected"
            :max-items="paginationItems[1]"
            pagination
            :data="ValidationRulesListData"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.PlanValidationRules") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create Validation Rule' })"
                  size="small"
                  >{{ $t("setup.label.CreateValidationRule") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.InputPlanId") }}</vs-th>
              <vs-th>{{ $t("setup.label.CheckinPlanId") }}</vs-th>
              <vs-th>{{ $t("setup.label.RuleAppliesTo") }}</vs-th>
              <vs-th>{{ $t("setup.label.Rule") }}</vs-th>

              <vs-th class="tHeadCenter">{{ $t("setup.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="index" :data="data" v-for="(Data, index) in data">
                <vs-td>{{
                  getPlanDescription(Data.inputPlanId)
                }}</vs-td>
                <vs-td>{{
                  getPlanDescription(Data.checkinPlanId)
                }}</vs-td>
                <vs-td>{{
                  getRulesAppliesTo(Data.ruleAppliesTo)
                }}</vs-td>
                <vs-td>{{ getRule(Data.rule) }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      :title="$t('setup.label.View')"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected(Data)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="EditIcon"
                      :title="$t('setup.label.Edit')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="editPriceRegion(Data.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      icon="TrashIcon"
                      :title="$t('setup.label.Delete')"
                      svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                      @click.stop="
                        deleteValidationRulePopup = true;
                        delId = Data.id;
                      "
                      class="icon_row"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
    <delete-popup
      :deletePopup="deleteValidationRulePopup"
      :title="$t('setup.label.ValidationRule')"
      @deletePressed="deletePlanValidationRuleMethod(delId)"
      @cancelPressed="deleteValidationRulePopup = false"
    ></delete-popup>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { AtomSpinner } from "epic-spinners";

export default {
  data() {
    return {
      loading: false,
      deleteValidationRulePopup: false,
      paginationItems: [5, 10, 15],
      delId: 0,
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      ValidationRulesListData: (state) =>
        state.planValidationRules.validationRulesList,
    }),
  },
  methods: {
    handleSelected(region) {
      this.$router.push({
        name: "View Validation Rule",
        params: { id: region.id },
      });
    },
    getPlanDescription(id) {
      const plan = this.ValidationRulesListData[0].planList.find((plan) => plan.id === id);
      return plan ? plan.planDescription : "N/A";
    },
    getRulesAppliesTo(id) {
      const plan = this.ValidationRulesListData[0].ruleAppliestoList.find((plan) => plan.id === id);
      return plan ? plan.mCodeValue : "N/A";
    },
    getRule(id) {
      const plan = this.ValidationRulesListData[0].ruleExpressionList.find((plan) => plan.id === id);
      return plan ? plan.mCodeValue : "N/A";
    },
    async deletePlanValidationRuleMethod(id) {
      try {
        this.deleteValidationRulePopup = false;
        await this.$store.dispatch("planValidationRules/deletePlanValidationRuleAction", id);
        await this.getPlanValidationRulesMethod();
        this.$swal({
            title: "Success",
            icon: "success",
            text: "Plan Validation Rule Deleted Successfully!",
            type: "success",
          });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPlanValidationRulesMethod() {
      try {
        await this.$store.dispatch(
          "planValidationRules/getPlanValidationRulesListAction"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },

    editPriceRegion(id) {
      this.$router.push({ name: "Edit Validation Rule", params: { id: id } });
    },
  },
  async mounted() {
    await this.getPlanValidationRulesMethod();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
